import QRCodeCredit from "./QRCodeCredit.container";

export default QRCodeCredit;
